export default "__VITE_ASSET__DbvP0gBh__"